"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEAM_MANAGE = exports.TASK_SUMMARY_PAGE = exports.TASK_LIST_PAGE = exports.SUBORG_MY_PAGE = exports.SUBORG_GRANT_MANAGE_PAGE = exports.START_SUBAPP_PAGE = exports.START_RFA_PAGE = exports.START_APP_PAGE = exports.SESSION_INFORMATION = exports.PROFILE_INFORMATION_TITLE = exports.PANEL_SESSIONS_LIST = exports.PANEL_REVIEW_STATUS = exports.PANEL_REVIEWER_TASKS = exports.PANEL_CHAIR_REVIEW = exports.PANEL_APPLICANT_OVERVIEW = exports.ORG_MY_PAGE = exports.ORGANIZATION_PROFILE_TITLE = exports.MY_REVIEW = exports.LOGIN = exports.HOME_PAGE = exports.HOME = exports.GRANT_PROFILE_TITLE = exports.GRANT_MANAGE_PAGE = exports.DETAILS_TITLE = exports.CURRENT_WORKLOAD_DASHBOARD = exports.CREATE_FUNDING_OPPORTUNITY = exports.BUSINESS_OBJECTIVES_TRACKER = exports.AWARD_REC_TRACKER = exports.APP_PAGE = exports.APPLICATION_DETAILS = exports.ADMIN_CONSOLE_PAGE = void 0;
var HOME = 'FEMAGO';
exports.HOME = HOME;
var HOME_PAGE = "".concat(HOME, " - Home Page");
exports.HOME_PAGE = HOME_PAGE;
var LOGIN = "".concat(HOME, " - Login");
exports.LOGIN = LOGIN;
var PROFILE_INFORMATION_TITLE = "".concat(HOME, " - User Profile");
exports.PROFILE_INFORMATION_TITLE = PROFILE_INFORMATION_TITLE;
var GRANT_PROFILE_TITLE = "".concat(HOME, " - Grant Profile");
exports.GRANT_PROFILE_TITLE = GRANT_PROFILE_TITLE;
var ORGANIZATION_PROFILE_TITLE = "".concat(HOME, " - Organization Profile");
exports.ORGANIZATION_PROFILE_TITLE = ORGANIZATION_PROFILE_TITLE;
var DETAILS_TITLE = "".concat(HOME, " - Award Recommendation");
exports.DETAILS_TITLE = DETAILS_TITLE;
var CURRENT_WORKLOAD_DASHBOARD = "".concat(HOME, " - Current Workload");
exports.CURRENT_WORKLOAD_DASHBOARD = CURRENT_WORKLOAD_DASHBOARD;
var GRANT_MANAGE_PAGE = "".concat(HOME, " - Manage My Grants");
exports.GRANT_MANAGE_PAGE = GRANT_MANAGE_PAGE;
var SUBORG_GRANT_MANAGE_PAGE = "".concat(HOME, " - Manage My Suborganization Grants");
exports.SUBORG_GRANT_MANAGE_PAGE = SUBORG_GRANT_MANAGE_PAGE;
var ORG_MY_PAGE = "".concat(HOME, " - My Organizations");
exports.ORG_MY_PAGE = ORG_MY_PAGE;
var SUBORG_MY_PAGE = "".concat(HOME, " - My Suborganizations");
exports.SUBORG_MY_PAGE = SUBORG_MY_PAGE;
var TASK_SUMMARY_PAGE = "".concat(HOME, " - Task Summary");
exports.TASK_SUMMARY_PAGE = TASK_SUMMARY_PAGE;
var TASK_LIST_PAGE = "".concat(HOME, " - Task List");
exports.TASK_LIST_PAGE = TASK_LIST_PAGE;
var START_APP_PAGE = "".concat(HOME, " - Start Application");
exports.START_APP_PAGE = START_APP_PAGE;
var START_SUBAPP_PAGE = "".concat(HOME, " - Start Subapplication");
exports.START_SUBAPP_PAGE = START_SUBAPP_PAGE;
var START_RFA_PAGE = "".concat(HOME, " - Start Request for Assistance");
exports.START_RFA_PAGE = START_RFA_PAGE;
var CREATE_FUNDING_OPPORTUNITY = "".concat(HOME, " - Create Funding Opportunity");
exports.CREATE_FUNDING_OPPORTUNITY = CREATE_FUNDING_OPPORTUNITY;
var APP_PAGE = "".concat(HOME, " - Application");
exports.APP_PAGE = APP_PAGE;
var TEAM_MANAGE = "".concat(HOME, " - Manage Your Team");
exports.TEAM_MANAGE = TEAM_MANAGE;
var AWARD_REC_TRACKER = "".concat(HOME, " - Award Recommendation Tracker");
exports.AWARD_REC_TRACKER = AWARD_REC_TRACKER;
var MY_REVIEW = "".concat(HOME, " - Grants Outcomes Award Recommendations");
exports.MY_REVIEW = MY_REVIEW;
var BUSINESS_OBJECTIVES_TRACKER = "".concat(HOME, " - Business Objectives Tracker");
exports.BUSINESS_OBJECTIVES_TRACKER = BUSINESS_OBJECTIVES_TRACKER;
var PANEL_REVIEW_STATUS = "".concat(HOME, " - Review Status");
exports.PANEL_REVIEW_STATUS = PANEL_REVIEW_STATUS;
var PANEL_CHAIR_REVIEW = "Panel Chair Review";
exports.PANEL_CHAIR_REVIEW = PANEL_CHAIR_REVIEW;
var PANEL_REVIEWER_TASKS = "Reviewer tasks";
exports.PANEL_REVIEWER_TASKS = PANEL_REVIEWER_TASKS;
var PANEL_APPLICANT_OVERVIEW = "Applicant Overview";
exports.PANEL_APPLICANT_OVERVIEW = PANEL_APPLICANT_OVERVIEW;
var SESSION_INFORMATION = "".concat(HOME, " - Session Information");
exports.SESSION_INFORMATION = SESSION_INFORMATION;
var PANEL_SESSIONS_LIST = "".concat(HOME, " - Panel Sessions List");
exports.PANEL_SESSIONS_LIST = PANEL_SESSIONS_LIST;
var APPLICATION_DETAILS = "".concat(HOME, " - Application Details");
exports.APPLICATION_DETAILS = APPLICATION_DETAILS;
var ADMIN_CONSOLE_PAGE = "".concat(HOME, " - Admin Console");
exports.ADMIN_CONSOLE_PAGE = ADMIN_CONSOLE_PAGE;